'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _dotstatsuiteVisions = require('@sis-cc/dotstatsuite-visions');

var _ChartLegends = require('./legends/ChartLegends');

var _ChartLegends2 = _interopRequireDefault(_ChartLegends);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
  var type = _ref.type,
      chartData = _ref.chartData,
      source = _ref.source,
      logo = _ref.logo,
      copyright = _ref.copyright,
      chartOptions = _ref.chartOptions,
      isSticky = _ref.isSticky,
      target = _ref.target,
      width = _ref.width;

  var hasNoLegend = type === 'table' || (0, _utils.isChartNoData)({ data: chartData, type: type });
  var legend = hasNoLegend ? null : _react2.default.createElement(_ChartLegends2.default, { data: chartData, options: chartOptions, type: type, width: width });

  return _react2.default.createElement(
    'div',
    target ? { ref: target } : {},
    _react2.default.createElement(_dotstatsuiteVisions.DataFooter, {
      source: source,
      logo: logo,
      copyright: copyright,
      legend: legend,
      isSticky: isSticky
    })
  );
};

exports.default = Footer;